/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowUiAuthLoginIcon64Regular = forwardRef('ArrowUiAuthLoginIcon64Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 64 }, props),
        React.createElement("path", { d: "M42.5 9H22a1.5 1.5 0 0 1 0-3h20.5C48.299 6 53 10.701 53 16.5v31C53 53.299 48.299 58 42.5 58H22a1.5 1.5 0 0 1 0-3h20.5a7.5 7.5 0 0 0 7.5-7.5v-31A7.5 7.5 0 0 0 42.5 9Z" }),
        React.createElement("path", { d: "M25.19 18.94a1.5 1.5 0 0 0 0 2.12l9.439 9.44H4a1.5 1.5 0 0 0 0 3h30.629l-9.44 9.44a1.5 1.5 0 0 0 2.122 2.12l9.878-9.878a4.5 4.5 0 0 0 0-6.364l-9.878-9.879a1.5 1.5 0 0 0-2.122 0Z" })));
});
